module.exports = __webpack_public_path__ + "assets/img/pro_3.7a87ca12.png";